import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  erro: Error | null;
}

// Rede de proteção global: se QUALQUER tela quebrar durante o render, em vez de
// aparecer a tela em branco, mostramos uma mensagem clara com dois caminhos:
// "Tentar de novo" (recarrega) e "Voltar ao início". O erro vai para o console.
export default class ErroGlobal extends Component<Props, State> {
  state: State = { erro: null };

  static getDerivedStateFromError(erro: Error): Partial<State> {
    return { erro };
  }

  componentDidCatch(erro: Error, info: ErrorInfo): void {
    // Fica registrado no console para quem estiver depurando.
    // eslint-disable-next-line no-console
    console.error('[ErroGlobal] Algo deu errado nesta tela:', erro, info?.componentStack ?? '');
  }

  private tentarDeNovo = () => {
    window.location.reload();
  };

  private voltarAoInicio = () => {
    const base = typeof __BASE_PATH__ !== 'undefined' && __BASE_PATH__ ? __BASE_PATH__ : '/';
    window.location.assign(base);
  };

  render() {
    if (!this.state.erro) return this.props.children;

    return (
      <div className="flex min-h-screen items-center justify-center bg-background-100 px-5 py-8">
        <div className="w-full max-w-[420px] rounded-[22px] bg-background-50 p-8 text-center shadow-pcard">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-danger-50 text-danger-600">
            <i className="ri-emotion-sad-line text-[34px]" aria-hidden />
          </span>

          <h1 className="mt-4 text-[20px] font-extrabold text-foreground-950">
            Algo deu errado nesta tela
          </h1>
          <p className="mt-2 text-[14px] leading-relaxed text-foreground-600">
            Não foi culpa sua. Toque em <b>Tentar de novo</b> — se continuar, volte para o início.
          </p>

          <div className="mt-6 flex flex-col gap-3">
            <button
              type="button"
              onClick={this.tentarDeNovo}
              className="aperta flex h-14 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[18px] bg-primary-500 text-[15px] font-bold text-white transition-colors hover:bg-primary-600"
            >
              <span className="flex h-5 w-5 items-center justify-center">
                <i className="ri-refresh-line" aria-hidden />
              </span>
              Tentar de novo
            </button>

            <button
              type="button"
              onClick={this.voltarAoInicio}
              className="aperta flex h-14 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[18px] border border-background-200 bg-background-50 text-[15px] font-semibold text-foreground-800 transition-colors hover:bg-background-100"
            >
              <span className="flex h-5 w-5 items-center justify-center">
                <i className="ri-home-5-line" aria-hidden />
              </span>
              Voltar ao início
            </button>
          </div>
        </div>
      </div>
    );
  }
}